// extracted by mini-css-extract-plugin
export default {"bodyContainer":"EditStorageAccountModal__bodyContainer___WpzGi","label":"EditStorageAccountModal__label___jHiWi","footer":"EditStorageAccountModal__footer___wORcS"};